<template>
  <div class="container">
        <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="leftLine"></span>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding:20px;background:rgb(249,249,249)">
    <div>
      <el-button type="primary"
                 icon="el-icon-plus"
                 size="mini"
                 style="margin-bottom:10px"
                 @click="add">添加</el-button>
    </div>
    <el-table :data="tableData"
              style="width: 100%;margin-bottom: 20px;"
              row-key="id"
              border
              :tree-props="{children: 'children', hasChildren: 'hildren'}">
      <el-table-column type="selection"
                       width="55">
      </el-table-column>
      <el-table-column prop="id"
                       label="ID"
                       width="180">
      </el-table-column>
      <el-table-column prop="name"
                       label="标题"
                       width="180">
      </el-table-column>
      <el-table-column prop="path"
                       label="规则"
                       width="180">
      </el-table-column>
      <el-table-column prop="sort"
                       label="权重"
                       width="180">
      </el-table-column>
      <el-table-column prop="keepAlive"
                       label="菜单"
                       width="180">
        <template slot-scope="scope">
          <el-switch disabled
                     active-value='0'
                     @click.native="handleClick(scope.$index,scope.row)"
                     v-model="scope.row.keepAlive"
                     inactive-value='1'>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick1(scope.row)"
                     type="text"
                     size="small">编辑</el-button>
          <el-button type="text"
                     @click="deleteTable(scope.$index, tableData,scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title"
               style="width:1200px;margin:auto"
               :visible.sync="dialogFormVisible1">
      <el-form :model="form1"
               ref="form1"
               label-width="100px">
        <el-form-item label="菜单名称:"
                      prop="name"
                      :rules="[
      { required: true, message: '不能为空'}
    ]">
          <el-input v-model="form1.name"></el-input>
        </el-form-item>
        <el-form-item label="路径:">
          <el-input v-model="form1.path"></el-input>

        </el-form-item>
        <el-form-item label="排序值:"
                      prop="sort"
                      :rules="[
      { required: true, message: '不能为空'}
    ]">
          <el-input v-model="form1.sort" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型:"
                      prop="type"
                      :rules="[
      { required: true, message: '不能为空'}
    ]">
          <el-select v-model="form1.type"
                     placeholder="请选择">
            <el-option label="菜单"
                       value="0">
            </el-option>
            <el-option label="按钮"
                       value="1">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按钮功能:"
                      v-if="form1.type==1"
                      prop="permission"
                      :rules="[
      { required: true, message: '不能为空'}
    ]">
          <el-select v-model="form1.permission"
                     placeholder="请选择">
            <el-option label="导入"
                       value="import">
            </el-option>
            <el-option label="导出数据"
                       value="export">
            </el-option>
                 <el-option label="导出模板"
                       value="exportT">
            </el-option>
            <el-option label="新增"
                       value="add">
            </el-option>
            <el-option label="编辑"
                       value="edit">
            </el-option>
            <el-option label="查看"
                       value="see">
            </el-option>
            <el-option label="删除"
                       value="delete">
            </el-option>
             <el-option label="批量删除"
                       value="deletes">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="父菜单:">
          <el-cascader :options="options"
                       v-model="form1.parentId"
                       :props="{ checkStrictly: true,value:'id' }"
                       clearable></el-cascader>

        </el-form-item>
        <el-form-item label-width="0"
                      style="text-align:center">
          <el-button @click="dialogFormVisible1 = false">取 消</el-button>
          <el-button type="primary"
                     @click="submitForm1('form1')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import { getmenu, postmenu, getmenuTree, delmenu, putmenu } from '../../API'
export default {
  data () {
    return {
      tableData: [],
      title: '新建菜单',
      form1: {
        name: '',
        path: '',
        sort: '',
        type: '',
        parentId: ''
      },
      dialogFormVisible1: false,
      options: []
    }
  },
  created () {
    getmenuTree().then(res => {
      if (res.code === 0) {
        this.tableData = JSON.parse(JSON.stringify(res.data))
        this.options = JSON.parse(JSON.stringify(res.data))
      }
    })
  },
  methods: {
    add () {
      this.dialogFormVisible1 = true
      this.title = '新增菜单'
      this.form1={}
      if (this.$refs.form1) {
        this.$refs.form1.resetFields()
      }
    },
    handleClick (index, row) {
      if (row.keepAlive == 0) {
        this.$confirm('是否关闭启用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = row
          params.keepAlive = 1
          params.menuId = params.id
          putmenu(params).then((res) => {
            if (res.code === 0) {
              this.$message.success('成功关闭启用！');
               getmenuTree().then(res => {
                  if (res.code === 0) {
                    this.options = res.data
                    this.tableData = JSON.parse(JSON.stringify(res.data))
                  }
                })
            }
            else {
              if (res.errorCode == '5000') {
                setTimeout(function () {
                  _this.$router.push({ path: '/login' });
                }, 500)
              }
              else {
                this.$message.error(res.msg);
              }
            }
          }).catch(error => {
            this.$message.error('网络加载失败！');
          }).finally()
        }).catch(() => {
        });
      }
      else {
        let params = row
        params.keepAlive = 0
        params.menuId = params.id
        putmenu(params).then((res) => {
          if (res.code ==0) {
             getmenuTree().then(res => {
                  if (res.code === 0) {
                    this.options = res.data
                    this.tableData = JSON.parse(JSON.stringify(res.data))
                  }
                })
            this.$message.success('成功开启启用！');
          }
          else {
            if (res.errorCode == '5000') {
              setTimeout(function () {
                _this.$router.push({ path: '/login' });
              }, 500)
            }
            else {
              this.$message.error(res.msg);
            }
          }
        }).catch(error => {
          console.log(error)
        }).finally()
      }
    },
    deleteTable (index, rows, id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1);
        delmenu(id).then(res => {
          if (res.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            getmenuTree().then(res => {
              if (res.code === 0) {
                this.tableData = JSON.parse(JSON.stringify(res.data))
              }
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleClick1 (row) {
      this.dialogFormVisible1 = true
      this.title = '编辑菜单'
      this.form1 = row
    },
    submitForm1 (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form1.id) {
            let params = this.form1
            params.parentId = this.form1.parentId ? this.form1.parentId[this.form1.parentId.length - 1] : '-1'
            params.menuId = params.id
            putmenu(this.form1).then(res => {
              if (res.code === 0) {
                this.$message.success('成功修改！');
                getmenuTree().then(res => {
                  if (res.code === 0) {
                    this.options = res.data
                    this.tableData = JSON.parse(JSON.stringify(res.data))
                  }
                })
              }
            })
            this.dialogFormVisible1 = false
          }
          else {
            let params = this.form1
            params.parentId = this.form1.parentId ? this.form1.parentId[this.form1.parentId.length - 1] : '-1'
            params.menuId = params.id
            postmenu(this.form1).then(res => {
              if (res.code === 0) {
                this.$message.success('成功添加！');
                getmenuTree().then(res => {
                  if (res.code === 0) {
                    this.options = res.data
                    this.tableData = JSON.parse(JSON.stringify(res.data))
                  }
                })
              }
            })
            this.dialogFormVisible1 = false
          }

        } else {
          return false;
        }
      });
    },
  },
}
</script>
<style lang='less' scoped>
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
/deep/ .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label {
    cursor: pointer;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.el-breadcrumb__item {
  float: none;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
</style>